import { AbstractPaintableItem } from "./AbstractPaintableItem";
import { TypeKeys } from "./TypeKeys";

export class TriangleItem extends AbstractPaintableItem {
  constructor() {
    super(TypeKeys.TriangleItem);
  }
 
  protected createCloneInstance(): TriangleItem {
    return new TriangleItem();
  }
}
